import React, { useEffect } from "react";
import "./index.less";
import Button from "@material-ui/core/Button";
import DownloadIcon from "@material-ui/icons/GetApp";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import cx from "classnames";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import { DarkTooltip } from "../material-tooltip";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { IconButton, Zoom } from "@material-ui/core";
import { ShowToast, toastType } from "../../../utils/toast-service";

/** styling properties */
const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		"& .MuiFormControlLabel-label.Mui-disabled": {
			color: "#fff"
		}
	},
	paper: {
		marginRight: theme.spacing(2)
	}
}));

/** function for download ssrs report */
export default function DownloadSSRSPopUp({
	fundsList = [],
	reportList = [],
	maxChar = 24,
	downloadReport = () => {},
	dataTip = "Tooltip Here",
	downloadBtnLabel = "Download",
	currentFundId = "",
	defaultReportId = 1,
	isOpen = false,
	runReport = () => {},
	clearFilter = () => {},
	isPopupOpen = true,
	enableDownload,
	isClear = true, // enable/disable clear filter button
	isInErrorState=false,
	errorMessage=""
}) {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const [fundValue, setFundValue] = React.useState(currentFundId);
	const [reportFormat, setReportFormat] = React.useState("excel");
	const [reportType, setReportType] = React.useState(defaultReportId);
	const [selectedReport, setSelectedReport] = React.useState(null);
	const anchorRef = React.useRef(null);
	const [downloadEnable, setDownloadEnable] = React.useState(true);

	/**
	 * customizes the instance value that is exposed to parent components
	 */
	useEffect(() => {
		onReportSelect(reportType);
	}, [reportType]);

	useEffect(() => {
		setDownloadEnable(isPopupOpen);
	}, [enableDownload]);

	useEffect(() => {
		setFundValue(currentFundId);
	}, [currentFundId]);

	useEffect(() => {
		setReportType(defaultReportId);
		onReportSelect(defaultReportId);
	}, [defaultReportId]);

	/**
	 * set values on toggle change event depends upon condition.
	 */
	const handleToggle = () => {
		setReportFormat("excel");
		if(!isInErrorState){
		isOpen && runReport();
		isPopupOpen && setOpen(prevOpen => !prevOpen);}
		else{
			ShowToast(errorMessage,toastType.ERROR,2000,500);
		}
	};

	/**
	 * set properties depends upon condition.
	 * @param {*} event
	 * @returns
	 */
	const handleClose = event => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
	};

	/**
	 * download report onclick event.
	 * @param {*} event
	 */
	const handleDownloadReport = () => {
		downloadReport(selectedReport, reportFormat);
		setReportFormat("excel");
		setOpen(false);
	};

	/**
	 * download report by id with format option.
	 * @param {*} id - report id
	 */
	const onReportSelect = id => {
		const report = reportList.filter(report => report.id === id)[0];
		setSelectedReport(report);

		if (!report.pdfDownload && reportFormat === "pdf") {
			setReportFormat("excel");
		}
		if (!report.excelDownload && reportFormat === "excel") {
			setReportFormat("pdf");
		}
		if (!report.mhtmlDownload && reportFormat === "mhtml") {
			setReportFormat("mhtml");
		}
		if (!report.wordDownload && reportFormat === "word") {
			setReportFormat("word");
		}
	};

	return (
		<div className={`${classes.root} download-popup`}>
			{isOpen == true &&
			isClear && ( // enable/disable clear filter button
			<Button
						key={"downloadClearFilterButton"}
						className={"clearFilter-btn"}
						variant={"contained"}
						onClick={() => {
							clearFilter();
						}}
			>
				{" "}
				{"Clear Filters\r"}
			</Button>
				)}
			<DarkTooltip title={dataTip} arrow key={"DownloadDarkTooltip"}>
				<IconButton
					key={"downloadIconBtn"}
					ref={anchorRef}
					aria-controls={open ? "menu-list-grow" : undefined}
					aria-haspopup={"true"}
					onClick={handleToggle}
					className={isOpen ? "" : "downloadIconBtn"}
				>
					{isOpen == true ? (
						<>
							<Button
								key={"generateReportButton"}
								className={"runReport-btn"}
								variant={"contained"}
								onClick={() => {
									runReport();
								}}
							>
								{" "}
								{"Generate Report\r"}
							</Button>
						</>
					) : (
						<DownloadIcon className={"white-button"} />
					)}
				</IconButton>
			</DarkTooltip>
			<>
				{downloadEnable == true ? (
					<Popper
						key={"popup-downloadOptionsPopper"}
						open={open}
						className={"popup-downloadOptions"}
						anchorEl={anchorRef.current}
						role={undefined}
						transition
						disablePortal
					>
						{({ TransitionProps }) => (
							<Zoom
								in={open}
								{...TransitionProps}
								timeout={{ enter: 300, exit: 300 }}
							>
								<Paper className={"paperContainer"}>
									<ClickAwayListener onClickAway={handleClose}>
										<MenuList
											autoFocusItem={open}
											id={"menu-list-grow"}
											className={"downloadOptions"}
										>
											<div className={"controlParent"}>
												{fundsList.length ? (
													<FormControl
														key={"reportFormControl"}
														component={"fieldset"}
														className={"fieldset"}
													>
														<RadioGroup
															key={"reportRadioGroup"}
															aria-label={"Report List"}
															name={"report"}
															className={"radioGroup"}
															value={fundValue}
															onChange={event =>
																setFundValue(parseInt(event.target.value))}
														>
															{fundsList.length &&
																fundsList.map(({ id, label }, i) => {
																	return (
																		<FormControlLabel
																			key={`menulist${i}`}
																			value={id}
																			control={<Radio color={"primary"} />}
																			label={
																				label && label.length > maxChar
																					? `${label.substring(0, maxChar)}...`
																					: label
																			}
																		/>
																	);
																})}
														</RadioGroup>
													</FormControl>
												) : (
													""
												)}
												<div className={"reportTypeParent"}>
													<FormControl
														key={"reportTypeParentFormControl"}
														component={"fieldset"}
														className={"fieldset"}
													>
														<RadioGroup
															key={"reportTypeParentRadioGroup"}
															aria-label={"Portfolio Type"}
															name={""}
															className={"radioGroup"}
															value={reportType}
															onChange={event =>
																setReportType(parseInt(event.target.value))}
														>
															{reportList.length &&
																reportList.map(({ id, label }, i) => {
																	return (
																		<FormControlLabel
																			key={`reportList${i}`}
																			value={id}
																			control={
																				<Radio
																					key={`reportListRadio${i}`}
																					className={isOpen ? "radio-btn" : ""}
																					color={"primary"}
																				/>
																			}
																			label={label}
																		/>
																	);
																})}
														</RadioGroup>
													</FormControl>
													<FormControl
														key={"reportFormatFormControl"}
														component={"fieldset"}
														className={"fieldset"}
														style={{
															marginTop: "0.5rem"
														}}
													>
														<RadioGroup
															key={"reportFormatRadioGroup"}
															aria-label={"Report Type"}
															name={"reportFormat"}
															className={"radioGroup"}
															style={{
																display: "inline-block"
															}}
															value={reportFormat}
															onChange={event =>
																setReportFormat(event.target.value)}
														>
															<FormControlLabel
																key={"excelFormControlLabel"}
																value={"excel"}
																control={
																	<Radio
																		className={isOpen && "radio-btn"}
																		color={"primary"}
																	/>
																}
																label={"Excel"}
																className={cx(
																	selectedReport &&
																		!selectedReport.excelDownload
																		? "disabled"
																		: ""
																)}
															/>
															<FormControlLabel
																key={"pdfFormControlLabel"}
																value={"pdf"}
																control={
																	<Radio
																		className={isOpen && "radio-btn"}
																		color={"primary"}
																	/>
																}
																label={"PDF"}
																className={cx(
																	selectedReport && !selectedReport.pdfDownload
																		? "disabled"
																		: ""
																)}
															/>
														</RadioGroup>
													</FormControl>
													<Button
														key={"downloadReportButton"}
														onClick={handleDownloadReport}
														className={"download-button"}
													>
														<span>{downloadBtnLabel}</span>
													</Button>
												</div>
											</div>
										</MenuList>
									</ClickAwayListener>
								</Paper>
							</Zoom>
						)}
					</Popper>
				) : null}
			</>
		</div>
	);
}
